import { SearchOptionsModel } from '@app/data/models';
import { EmailTemplateModel } from '@app/data/models/email-template.model';

const ns = '[Manage Emails]';

export class SearchTemplates {
    static readonly type = `${ns} Search Links`;
    constructor(public model?: SearchOptionsModel) {}
}

export class SearchTemplatesFailure {
    static readonly type = `${ns} Search Links Failure`;
    constructor(public error: any) {}
}

export class SaveEmailTemplate {
    static readonly type = `${ns} Save Email Template`;
}

export class SaveEmailTemplateFailure {
    static readonly type = `${ns} Save Email Template Failure`;
    constructor(public error: any) {}
}

export class SaveEmailTemplateContent {
    static readonly type = `${ns} Save Email Template Content`;
    constructor(public content: string, public rowKey: string) {}
}

export class SaveEmailTemplateContentFailure {
    static readonly type = `${ns} Save Email Template Content Failure`;
    constructor(public error: any) {}
}

export class ConfirmDeleteTemplates {
    static readonly type = `${ns} Confirm Delete Templates`;
    constructor(public templates: EmailTemplateModel[]) {}
}

export class DeleteTemplates {
    static readonly type = `${ns} Delete Templates`;
    constructor(public rowKeys: string[]) {}
}

export class DeleteTemplatesFailure {
    static readonly type = `${ns} Delete Templates Failure`;
    constructor(public error: any) {}
}

export class LoadEmailTemplate {
    static readonly type = `${ns} Load Email Template`;
    constructor(public rowKey: string) {}
}

export class LoadEmailTemplateFailure {
    static readonly type = `${ns} Load Email Template Failure`;
    constructor(public error: any) {}
}

export class CopyTemplate {
    static readonly type = `${ns} Copy Template`;
    constructor(public template: EmailTemplateModel) {}
}

export class LoadEmailTemplates {
    static readonly type = `${ns} Load Email Templates`;
}

export class LoadEmailTemplatesFailure {
    static readonly type = `${ns} Load Email Templates Failure`;
    constructor(public error: any) {}
}

export class ShowPreviewEmail {
    static readonly type = `${ns} Show Preview Email`;
    constructor(public model: { template: string; subject?: string | null }) {}
}
